import React from 'react'

const ConfirmSub = () => {
  return (
    <div className="container-fluid pt-8">
        <div className="cardsucess bodysucess justify-content-center">
          <div className="divsucess" style={{ height: '100px', width: '100px' }}>
            <i className="checkmark isucess" style={{ lineHeight: '100px', fontSize: '50px', marginLeft: '-7px' }}>✓</i>
          </div>

          <h1 className="hsucess">Your payment success!</h1>
          <p className="psucess">Thank you for your payment. Your transaction has been processed successfully. 
                Please check your email for login instructions.</p><br />
        </div>  
      </div>
  )
}

export default ConfirmSub